import PREDEFINED_INTERVALS from '../../../../../shared/constants/predefinedIntervals';
import isValidDate from '../../../../../shared/utils/isValidDate';
import { EMPTY_NAME, REPORT_PARAMS } from '../constants';

export function getScheduledIntervalValues(selectedInterval) {
  switch (selectedInterval) {
    case PREDEFINED_INTERVALS.TODAY:
      return ['{СЕГОДНЯ}', '{СЕГОДНЯ}+1'];
    case PREDEFINED_INTERVALS.YESTERDAY:
      return ['{СЕГОДНЯ}-1', '{СЕГОДНЯ}'];
    case PREDEFINED_INTERVALS.DAY:
      return ['{СЕЙЧАС}-1', '{СЕЙЧАС}'];
    case PREDEFINED_INTERVALS.WEEK:
      return ['{СЕГОДНЯ}-7', '{СЕГОДНЯ}'];
    case PREDEFINED_INTERVALS.CURRENT_MONTH:
      return ['{ТЕК_МЕС_НАЧ}', '{СЕГОДНЯ}'];
    case PREDEFINED_INTERVALS.LAST_MONTH:
      return ['{ПРЕД_МЕС_НАЧ}', '{ПРЕД_МЕС_КОН}'];
    case PREDEFINED_INTERVALS.CUSTOM:
    default:
      return null;
  }
}

function detectPredefinedInterval(valueStr) {
  const values = valueStr.split(', ').map((v) => v.trim());

  if (values.length !== 2) {
    return null;
  }

  return (
    Object.values(PREDEFINED_INTERVALS).find((key) => {
      const intervalValues = getScheduledIntervalValues(key);
      return Array.isArray(intervalValues) && intervalValues[0] === values[0] && intervalValues[1] === values[1];
    }) || PREDEFINED_INTERVALS.CUSTOM
  );
}

export const createControlForParam = (param) => {
  const { type, name = EMPTY_NAME, code, defaultValue, isRequired } = param;
  const nowDate = new Date();
  const id = crypto.randomUUID();
  const isoRegexp =
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)-(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)((-(\d{2}):(\d{2})|Z)?)$/;
  switch (type) {
    case REPORT_PARAMS.TEXT:
      return {
        ...param,
        id,
        label: name,
        value: (typeof defaultValue === 'string' && defaultValue.trim()) || '',
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.NUMERIC:
      return {
        ...param,
        id,
        label: name,
        value: (typeof defaultValue === 'number' && defaultValue) || '',
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.DATETIME:
      return {
        ...param,
        id,
        label: name,
        value: (typeof defaultValue === 'string' && isValidDate(defaultValue) && new Date(defaultValue)) || nowDate,
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.DATE:
      return {
        ...param,
        id,
        label: name,
        value: (typeof defaultValue === 'string' && isValidDate(defaultValue) && new Date(defaultValue)) || nowDate,
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.INTERVAL:
    case REPORT_PARAMS.DATE_INTERVAL:
      return {
        ...param,
        id,
        label: name,
        value:
          typeof defaultValue === 'string' && isoRegexp.test(defaultValue) && defaultValue.length === 49
            ? [new Date(defaultValue.slice(0, 24)), new Date(defaultValue.slice(-24))]
            : [],
        helpData: { intervalName: PREDEFINED_INTERVALS.TODAY },
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.USER:
      return {
        ...param,
        id,
        label: name,
        value: null,
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.DIVISION:
      return {
        ...param,
        id,
        label: name,
        value: null,
        type,
        isError: false,
        code,
        isRequired,
      };
    default:
      return null;
  }
};

export const createControlForParamReportTask = (param, value) => {
  const { type, name = EMPTY_NAME, code, isRequired } = param;
  const nowDate = new Date();
  const id = crypto.randomUUID();
  switch (type) {
    case REPORT_PARAMS.TEXT:
      return {
        ...param,
        id,
        label: name,
        value: (typeof value === 'string' && value.trim()) || '',
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.NUMERIC:
      return {
        ...param,
        id,
        label: name,
        value: (typeof value === 'number' && value) || '',
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.DATETIME:
      return {
        ...param,
        id,
        label: name,
        value: (typeof value === 'string' && isValidDate(value) && new Date(value)) || nowDate,
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.DATE:
      return {
        ...param,
        id,
        label: name,
        value: (typeof value === 'string' && isValidDate(value) && new Date(value)) || nowDate,
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.INTERVAL:
    case REPORT_PARAMS.DATE_INTERVAL:
      return {
        ...param,
        id,
        label: name,
        value: typeof value === 'string' && value.includes(', ') ? value.split(', ') : [],
        helpData: { intervalName: detectPredefinedInterval(value) },
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.USER:
      return {
        ...param,
        id,
        label: name,
        value,
        helpData: { initialAppUserId: value },
        type,
        isError: false,
        code,
        isRequired,
      };
    case REPORT_PARAMS.DIVISION:
      return {
        ...param,
        id,
        label: name,
        value,
        helpData: { initialDivisionId: value },
        type,
        isError: false,
        code,
        isRequired,
      };
    default:
      return null;
  }
};
